/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { Button } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { SidebarTextField } from "~/components/SidebarForm/inputs/SidebarTextField";
import { SidebarForm } from "~/components/SidebarForm/SidebarForm";
import { SidebarFormButtons } from "~/components/SidebarForm/SidebarFormButtons";
import { showSuccess } from "~/components/Toast";
import { ROUTES } from "~/routing";
import {
  generateActionSuccessText,
  itHasNotOnlyWhitespace,
  useAxios,
} from "~/tools";
import { maxLength } from "~/tools/validation/validators";

type Values = {
  automatedPriceDefault: string;
  automatedPriceMin: string;
  name: string;
  nonAutomatedPriceDefault: string;
  nonAutomatedPriceMin: string;
};

function ProductAdd() {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  const methods = useForm();

  const history = useHistory();
  const { showError } = useShowError();
  const { Axios } = useAxios();

  const onSubmit = async (values: Values) => {
    const organizeValues = { name: values.name };
    try {
      const { data } = await Axios().post("/catalog/products", organizeValues);
      showSuccess(generateActionSuccessText(`Product`)()("added")());
      history.push(`${ROUTES.productCatalog.index}/${data.id}`);
    } catch (e) {
      showError(e.response);
    }
  };

  return (
    <>
      <Button
        onClick={() => setIsSidebarOpen(true)}
        css={{ marginLeft: "auto" }}
        icon="plus"
      >
        Add new Product
      </Button>

      <SidebarForm
        title="Add new product"
        open={isSidebarOpen}
        setOpen={setIsSidebarOpen}
        formMethods={methods}
        submit={onSubmit}
      >
        <SidebarTextField
          name="name"
          label="Name"
          required
          registerOptions={{
            ...maxLength(255),
            validate: itHasNotOnlyWhitespace,
          }}
        />

        <SidebarFormButtons
          submitEnabled={!!methods.watch("name")}
          onCancel={() => setIsSidebarOpen(false)}
        />
      </SidebarForm>
    </>
  );
}

export { ProductAdd };
